<template>
    <div class="widget-clock">
        <div :class="getStatusHeader.header.minimaze ? 'widget-clock-title' : 'widget-clock-title widget-clock-title-minimaze'"
            @click="switchShowMenu">
            {{title}}
        </div>
        <div class="widget-clock-time">
            <span>{{time.hours}}:{{time.minutes}}:{{time.seconds}}</span>
        </div>
        <div class="widget-clock-menu" v-show="showMenu">
            <div v-for="(item,index) in itemsMenu" :key="index" class="widget-clock-menu_item" @click="changeZone(item.zone, item.title)">
                {{item.title}}
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    props: {
        zone:{default:0},
        title:{default:'Москва (GMT+3)'}
    },
    data() {
        return {
            time:{},
            itemsMenu: [
                {
                    title:'Москва (GMT+3)',
                    zone:3
                },
                {
                    title:'Лондон (GMT)',
                    zone:0
                },
                {
                    title:'Нью-ЙОРК (GMT-5)',
                    zone:-5
                },
                {
                    title:'Токио (GMT+9)',
                    zone:9
                }
            ],
            showMenu:false
        }
    },
    computed: {
        ...mapGetters({
            getStatusHeader:'usersets/getSettings'
        })
    },
    methods: {
        setTime(hours, minutes, seconds)
        {
            this.time = {
                hours:hours,
                minutes:minutes,
                seconds:seconds
            }
        },
        changeZone(zone, title) {
            this.switchShowMenu();
            let clockOptions = {titleZone:title, zone:zone}
            this.$emit('changeClock', clockOptions);
        },
        getTime() {
            let interval = setInterval(() => {
            let timeInterval = this.zone * 60
            let date = new Date();
            let currentTime = (timeInterval + date.getTimezoneOffset())*60*1000;
            let zoneTime = new Date(date.getTime() + currentTime)
            let hours = zoneTime.getHours(); // 0 - 23
            let minutes = zoneTime.getMinutes(); // 0 - 59
            let seconds = zoneTime.getSeconds(); // 0 - 59
    
            hours = (hours < 10) ? "0" + hours : hours;
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            seconds = (seconds < 10) ? "0" + seconds : seconds;
            this.setTime(hours,minutes,seconds)
            }, 1000);
        },
        switchShowMenu() {
            this.showMenu = !this.showMenu;
        }
    },
    created() {
         this.getTime();
    }       
}
</script>
<style lang="less" scoped>
@keyframes change-line { 
    from {
        min-height: 32px;
    }
    to {
        min-height: 10px;
    }
}
@keyframes change-line-full { 
    from {
        min-height: 10px;
    }
    to {
        min-height: 32px;
    }
}
@keyframes change-margin-bottom { 
    from {
        margin-bottom: 8px;
    }
    to {
        margin-bottom: 3px;
    }
}
@keyframes change-margin-bottom-full { 
    from {
        margin-bottom: 3px;
    }
    to {
        margin-bottom: 8px;
    }
}
@keyframes change-margin-top { 
    from {
        margin-top: 0px;
    }
    to {
        margin-top: 4px;
    }
}
@keyframes change-margin-top-full { 
    from {
        margin-top: 4px;
    }
    to {
        margin-top: 0px;
    }
}
.widget-clock {
    width: 123px;
    height: 100%;
    display: block;
    background: #3d536b;
    margin-left: 1px;
    &-menu {
        position: absolute;
        top:4px;
        width: 123px;
        z-index: 1;
        &_item {
            font-family: Arimo;
            background-color: #3d536b;
            font-size: 10px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 23px;
            letter-spacing: 0.4px;
            text-align: center;
            color: var(--white);
            margin-bottom: -1px;
            text-transform: uppercase;
            margin-top:0; 
            border-top: 1px solid #324258;
            border-bottom: 1px solid #324258;
            cursor: pointer;
        }
    }
    &-title {
        animation: change-line-full 0.6s ease-in 1;
        //animation: change-margin-bottom-full 0.6s ease-in 1;
        //animation: change-margin-top-full 0.6s ease-in 1;
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 32px;
        letter-spacing: 0.4px;
        text-align: center;
        color: var(--white);
        margin-bottom: 8px;
        text-transform: uppercase;
        margin-top:0;
        cursor: pointer;
        &-minimaze {
            animation: change-line 0.6s ease-in 1;
            //animation: change-margin-bottom 0.6s ease-in 1;
            //animation: change-margin-top 0.6s ease-in 1;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 10px;
            margin-bottom: 3px;
            padding-top: 4px;
        }
    }
    &-time {
        font-family: Arimo;
        font-size: 20px;
        font-style: normal;
        font-stretch: normal;
        font-weight: bold;
        line-height: 1;
        letter-spacing: normal;
        color: #00ffd0;
        max-height: 100%;
        margin-bottom: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>

